import { Component, Host, h, Prop, Element } from '@stencil/core';
import { versionComponent } from '../../global/inject-dependencies';

@Component({
  tag: 'ui-paragraph',
  styleUrl: 'ui-paragraph.scss',
  shadow: true,
})
export class UiParagraph {
  @Element() el: HTMLElement;

  /**
   * Specifies into how many columns the text is divided into. The default value is 1.
   */
  @Prop() columns = 1;

  render() {
    return (
      <Host
        style={{
          'column-count': this.columns.toString(),
        }}
      >
        <slot></slot>
      </Host>
    );
  }
}

versionComponent(UiParagraph);
